var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h24v24H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.02083)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA0UlEQVRoge2YzQqDMBCEPfncvZm+Z7WPUSP0UIqE2Z9sNjAfzEWi7leJjF0WQgjJylrzrDlqPgmy15TvXBAlwdB3KahAll/+P29U4PekDIjnoYAzFBgNBUZDgdFkm0cMBUYDCUgrtLjiGoAEtBUarrgGIAFthYYrrgFIQLpRIjcWBTzWW6CAx3oLFJCs17yK0bxmF9hmFYBqS489ELlPKOBxTRMUcLimCQrcHEfzsI3eHki6ngJaduXNm/0kEu1HfbOfRHL1jEsCfRKRf6sQ0oMT1AkG0ldw6+AAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.847bb4a04a3ba68bbf70a374b6aa8238.svg";
export { ForwardRef as ReactComponent };